import { useEffect, useRef, useState } from "react";
import "./StartAlert.scss";
import DataService from "../../Services/DataService";
import { closePopup } from "../../App/Slices/popupSlice";
import { useDispatch } from "react-redux";

export const StartAlert = () => {
  const [alertCounter, setAlertCounter] = useState(100);

  const dispatch = useDispatch();

  useEffect(() => {
    let int = setInterval(() => {
      DataService.cloud_function.online().then().catch();
      setAlertCounter((prevState) => {
        let newState = prevState - 10;
        if (newState <= 0) {
          clearInterval(int);
          dispatch(closePopup(0));
        }
        return newState;
      });
    }, 1000);
    return () => {
      clearInterval(int);
    };
  }, []);

  const audioRef = useRef<HTMLAudioElement>(null);

  const audioUrl =
    "https://storage.googleapis.com/download/storage/v1/b/hq-slime-shadies-f1a50/o/646df9998493ca002b327392?alt=media&timestamp=1684928922473";

  useEffect(() => {
    if (!audioRef.current) return;

    if (audioRef.current.paused) audioRef.current.play();
  }, []);
  return (
    <div className="start-alert-box">
      <audio ref={audioRef} src={audioUrl} />
      <h2>Game will start now please don't leave this tab.</h2>
      <input type="range" disabled value={alertCounter} />
    </div>
  );
};
